import axios from "axios";
import KeycloakUserService from "../keycloak/KeycloakUserService";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { useSelector } from "react-redux";
const SEARCH = "/search";
const PIN_DOCUMENT = "/pindocument";
const FEEDBACK = "/feedback";
const FEATURE_FLAG = process.env.REACT_APP_FEATURE_FLAG_URL;
const QA_SYSTEM = process.env.REACT_APP_QNA_URL;
const FEEDBACK_COMMENT = "/feedback-comment";
const FEEDBACKCOMMENT = "/feedbackcomment/";
const RAISESAFEEDBACK = "/problem";
const SAS_URL = "/sas-url";
const ALL_PINNED_DOC = "/allpinneddocs";
const GET_PROCEDURE = "/procedure";
const LOG_USER_ACTION = "/loguseraction"
const SARAS_URL = process.env.REACT_APP_SARAS_URL;

function keyCloakLoggedInOrToKenCheck() {
  if (KeycloakUserService.isTokenExpired()) {
    KeycloakUserService.doLogout();
  }

  if (KeycloakUserService.isLoggedIn()) {
    axios.defaults.params = {};
    axios.defaults.params["username"] = KeycloakUserService.getUsername();
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + KeycloakUserService.getToken();
  }
}

// api for searching all documents
export async function searchApi(query) {
  keyCloakLoggedInOrToKenCheck();
  //get searchId state from redux

  query.browserFingerprint = (await getCurrentBrowserFingerPrint()).toString();
  if (query.searchId.split("_")[1]==`incorrect`){
    query.isIncorrectQuery = true
  } 
  return axios.post(SEARCH, query);
}

// api for feature flag implementation
export function featureFlagAPi() {
  const query = {
    client: process.env.REACT_APP_CLIENT,
    instance: process.env.REACT_APP_INSTANCE,
    product: process.env.REACT_APP_PRODUCT,
    project: process.env.REACT_APP_PROJECT,
  };
  return axios.get(FEATURE_FLAG, { params: query });
}

export function qaSystemApi(query) {
  return axios.post(QA_SYSTEM, query, {
    timeout: 90 * 1000, // Override the default timeout for this request
    headers: {
      "Content-Type": "application/json",
    },
  });
}


// api for adding feedback comments from form
export function feedbackComment(formData) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post(FEEDBACK_COMMENT, formData);
}

// api for getting all feedback for a particular document
export function viewFeedbackComment(documentId, id) {
  keyCloakLoggedInOrToKenCheck();
  return axios.get(FEEDBACK_COMMENT + "/" + documentId + "/" + id);
}

// api for fetching all pinned document for a particular user
export function getAllPinedMessage() {
  keyCloakLoggedInOrToKenCheck();
  return axios.get(PIN_DOCUMENT);
}

export function getAllPinnedDoc(data) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post(ALL_PINNED_DOC, data);
}

//api for getting a pinned document using id
export function getPindatabyId(pinId) {
  keyCloakLoggedInOrToKenCheck();
  return axios.get(PIN_DOCUMENT + "/" + pinId);
}

//api for adding a document as pinned
export function addPinDocument(data) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post(PIN_DOCUMENT, data);
}

//api for removing pinned doc from mongodb
export function deletePinDocument(data) {
  keyCloakLoggedInOrToKenCheck();
  return axios.delete(PIN_DOCUMENT + "/" + data);
}

//api for getting count of feedback
export function feedbackCount(documentId) {
  keyCloakLoggedInOrToKenCheck();
  return axios.get(FEEDBACKCOMMENT + documentId + "/count");
}

export function feedbackHelpful(feedbackData) {
  keyCloakLoggedInOrToKenCheck();
  return axios.get(FEEDBACK, feedbackData);
}

export function raiseAFeedbackApi(raiseAFeedbackData) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post(RAISESAFEEDBACK, raiseAFeedbackData);
}

export function getSasUrl(data) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post(SAS_URL, data);
}

export function getProcedure(data) {
  return axios.get(GET_PROCEDURE, data);
}
export function logUserAction(data) {
  keyCloakLoggedInOrToKenCheck();
  getCurrentBrowserFingerPrint().then((res) => {
    data.browserFingerprint = res.toString();
    return axios.post(LOG_USER_ACTION, data);
  }
  ).catch((err) => {
    return axios.post(LOG_USER_ACTION, data);
  })  
}

export function getHighlight(data) {
  keyCloakLoggedInOrToKenCheck();
  return axios.post("/getHighlight", data);
}


//saras api calls
export function getSarasAnswer(query) {
  keyCloakLoggedInOrToKenCheck();
  const answer_url = SARAS_URL + "/api/v1/answer";
  console.log("Saras URL:", answer_url);
  //set query parameters
  const params = {
    query: query
  };
  //remove username from params if it exists
  if (params.query.username) {
    delete params.query.username;
  }
  return axios.get(answer_url, { params:params});
}

// New streaming Saras API function using fetch for better header support
export async function getSarasAnswerStream(query, onChunk, onComplete, onError) {
  keyCloakLoggedInOrToKenCheck();
  
  try {
    const answer_url = SARAS_URL + "/api/v1/answer/stream";
    const params = new URLSearchParams({
      query: query
    });
    
    const response = await fetch(`${answer_url}?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${KeycloakUserService.getToken()}`,
        'Accept': 'text/event-stream',
        'Cache-Control': 'no-cache'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let accumulatedContent = '';
    let citations = [];
    let buffer = '';
    
    const processStream = async () => {
      try {
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) {
            break;
          }
          
          // Decode the chunk and add to buffer
          buffer += decoder.decode(value, { stream: true });
          
          // Split by lines to handle multiple SSE messages in one chunk
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // Keep the last incomplete line in buffer
          
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const dataStr = line.slice(6); // Remove 'data: ' prefix
              
              if (dataStr.trim() === '') {
                continue; // Skip empty data lines
              }
              
              try {
                const data = JSON.parse(dataStr);
                console.log("🔄 Streaming API: Parsed data:", data);
                
                if (data.type === 'chunk') {
                  accumulatedContent += data.content;
                  console.log("🔄 Streaming API: Chunk received:", data.content);
                  console.log("🔄 Streaming API: Total accumulated:", accumulatedContent.length, "chars");
                  
                  // Call the chunk callback with the accumulated content
                  if (onChunk) {
                    const startTime = performance.now();
                    console.log("🔄 Streaming API: Calling onChunk callback at", startTime);
                    onChunk({
                      content: data.content,
                      accumulated: accumulatedContent
                    });
                    const endTime = performance.now();
                    console.log("🔄 Streaming API: onChunk callback completed in", endTime - startTime, "ms");
                  }
                } else if (data.type === 'complete') {
                  // Extract citations from the final content
                  const sourcesMatch = accumulatedContent.match(/\n\nSources:\n(.+)$/s);
                  if (sourcesMatch) {
                    const sourcesHtml = sourcesMatch[1];
                    // Parse citations from the HTML
                    citations = parseCitationsFromHtml(sourcesHtml);
                  }
                  
                  const result = {
                    answer: accumulatedContent,
                    citations: citations
                  };
                  
                  if (onComplete) {
                    onComplete(result);
                  }
                  return result;
                }
              } catch (parseError) {
                console.error('Error parsing SSE data:', parseError, 'Data:', dataStr);
              }
            }
          }
        }
      } catch (streamError) {
        console.error('Stream reading error:', streamError);
        if (onError) {
          onError(streamError);
        }
        throw streamError;
      } finally {
        reader.releaseLock();
      }
    };
    
    return await processStream();
    
  } catch (error) {
    console.error('Fetch streaming error:', error);
    if (onError) {
      onError(error);
    }
    throw error;
  }
}

// Helper function to parse citations from HTML
function parseCitationsFromHtml(htmlContent) {
  const citations = [];
  
  // Parse the HTML to extract citation information
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const links = doc.querySelectorAll('a[data-citation-id], a[data-step-id]');
  
  links.forEach((link, index) => {
    const citationId = link.getAttribute('data-citation-id') || link.getAttribute('data-step-id');
    const citationType = link.getAttribute('data-citation-type');
    const navigationPath = link.getAttribute('data-navigate');
    
    if (citationId) {
      // Extract IDs from navigation path
      const pathParts = navigationPath.split('/');
      let rootId = null;
      let parentAuthoredId = null;
      
      if (citationType === 'ingested') {
        rootId = pathParts[pathParts.length - 1] || citationId;
      } else if (citationType === 'authored') {
        parentAuthoredId = pathParts[pathParts.length - 1] || citationId;
      }
      
      citations.push({
        id: citationId,
        rootId: rootId,
        parentAuthoredId: parentAuthoredId,
        title: link.textContent.trim(),
        type: citationType
      });
    }
  });
  
  return citations;
}